export const FORM_ROUTES = {
    order: 'order',
    employment: 'employment',
    configure: 'product-parameters-configure',
};

export const APP_ROUTES = {
    PRODUCT: `/:productCode`,
    DRAFT: `/:productCode/draft`,
    ORDER: `/:productCode/${FORM_ROUTES.order}`,
    EMPLOYMENT: `/:productCode/${FORM_ROUTES.employment}`,
    CONFIGURE: `/:productCode/${FORM_ROUTES.configure}`,
    CONFIRMATION: `/:productCode/confirmation`,
    SMS: `/:productCode/sms`,

    CALLBACK: '/callback',
    OUATH: '/oauth2/callback',
    CONTINUE: '/c',
    REDIRECT: '/redirect',
    RESULT: '/result',

    ERROR: '/error',
    UNEXPECTED_ERROR: '/unexpected-error',
    VERSION: '/version',
};
